import { authApi } from "../api";
import { IFormDataTemplate } from "../../Utils/types";
import { emailValidation, passwordValidation } from "../../Utils/validators";
import { ThunkAction } from "redux-thunk";
import { AppState, AppActions } from "../Store/store";

// Initial state
interface IAuthState {
  logined: boolean,
  error: string,
  authData: IFormDataTemplate
}

const initialState: IAuthState = {
  logined: false,
  error: '',
  authData: {
    email: {
      valid: true,
      touched: false,
      value: ''
    },
    password: {
      valid: true,
      touched: false,
      value: ''
    }
  }
}

// Action types
export const LOGIN = 'auth/LOGIN';
export const LOGOUT = 'auth/LOGOUT';
export const SET_ERROR = 'auth/SET_ERROR';
export const SET_AUTH_DATA = 'auth/SET_AUTH_DATA';

// Selectors
export const loginedSelector = (state: any) => state.auth.logined;
export const authDataSelector = (state: any) => state.auth.authData;
export const authErrorSelector = (state: any) => state.auth.error;

// Reducer
export function authReducer(state = initialState, action: any) {
  switch (action.type) {
    case LOGIN: {
      return {
        ...state,
        logined: true
      }
    }

    case LOGOUT: {
      return {
        ...state,
        logined: false
      }
    }

    case SET_ERROR: {
      return {
        ...state,
        error: action.payload
      }
    }

    case SET_AUTH_DATA: {
      return {
        ...state,
        authData: {
          ...state.authData,
          [action.name]: action.payload
        }
      }
    }

    default:
      return state;
  }
}

// Actions
export function auth(): ThunkAction<Promise<void>, AppState, unknown, AppActions> {
  return async (dispatch: any, getState: any) => {
    const state = getState();
    const form = {
      email: state.auth.authData.email.value,
      password: state.auth.authData.password.value
    }
    const response = await authApi.login(form);

    if (response.valid) {
      dispatch(login());
    } else {
      dispatch(setAuthError('invalid'));
    }
  }
}

interface SetAuthError {
  type: typeof SET_ERROR,
  payload: string
}
export function setAuthError(payload: string): SetAuthError {
  return {
    type: SET_ERROR,
    payload
  }
}

interface LoginType {
  type: typeof LOGIN
}
export function login(): LoginType {
  return {
    type: LOGIN
  }
}

interface LogOutType {
  type: typeof LOGOUT
}
export function logOut(): ThunkAction<Promise<void>, AppState, unknown, AppActions> {
  return async (dispatch: any) => {
    await authApi.logOut();
    dispatch({
      type: LOGOUT
    });
  }
}

interface SetAuthDataType {
  type: typeof SET_AUTH_DATA,
  name: string,
  payload: {
    touched: boolean,
    valid: boolean,
    value: string
  }
}
export function setAuthData(name: string, value: string): SetAuthDataType {
  let valid: boolean = false;
  if (name === 'email') {
    valid = emailValidation(value);
  } else {
    valid = passwordValidation(value, 6);
  }
  return {
    type: SET_AUTH_DATA,
    name,
    payload: {
      touched: true,
      valid,
      value
    }
  }
}

export type AuthActions =
  SetAuthDataType
  | LogOutType
  | SetAuthError;